import React from 'react';
import Card from '../../../shared/Card';

type Props = {
  journeyStage?: string;
  source?: string;
  productPolicy?: string;
};

const BusinessContextCard: React.FC<Props> = ({ journeyStage, source, productPolicy }) => {
  return (
    <Card title="Business Context" className="h-full">
      <div className="space-y-3">
        <div>
          <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Journey Stage</div>
          <div className="text-figma-sm text-figma-text-primary">{journeyStage || 'Not available'}</div>
        </div>
        <div>
          <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Source</div>
          <div className="text-figma-sm text-figma-text-primary capitalize">{source || 'Not available'}</div>
        </div>
        <div>
          <div className="text-figma-xs text-figma-text-secondary uppercase tracking-wide font-medium">Product / Policy</div>
          <div className="text-figma-sm text-figma-text-primary">{productPolicy || 'Not available'}</div>
        </div>
      </div>
    </Card>
  );
};

export default React.memo(BusinessContextCard);
